import { render, staticRenderFns } from "./DocAutocomplete.vue?vue&type=template&id=50f5a20b&scoped=true"
import script from "./DocAutocomplete.vue?vue&type=script&lang=js"
export * from "./DocAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./DocAutocomplete.vue?vue&type=style&index=0&id=50f5a20b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f5a20b",
  null
  
)

export default component.exports